import { addScript } from '@tunein/web-utils';
import find from 'lodash/find';
import { State, getState } from '../../../js/utils/applicationState';
import { v4 as uuidv4 } from 'uuid';
import reporter from '../reporter';
function handleError(slot, errorCallback, message) {
    if (slot?.formatDefinition?.reportError) {
        reporter.fail(slot, message);
    }
    if (errorCallback) {
        errorCallback(message);
    }
}
const truexNetworkController = {
    init() {
        addScript({ src: 'https://static.truex.com/js/client.js' }).catch(() => { });
    },
    serveAd(params) {
        return new Promise((resolve) => {
            const { slot, elementId, campaignId, campaignKey, unlockToken, onStart, onCredit, onFinish, onError, callbackHandler, } = params;
            if (!(global.truex &&
                slot &&
                elementId &&
                campaignKey &&
                getState(State.rtid))) {
                handleError(slot, onError, 'bad initialization');
                resolve();
                return;
            }
            slot.formatDefinition = find(slot.formats, (format) => format.adProvider === 'truex');
            if (!slot.formatDefinition) {
                handleError(slot, onError, 'bad initialization');
                resolve();
                return;
            }
            slot.requestId = uuidv4();
            slot.formatDefinition.adUnitId = campaignKey;
            slot.campaignId = campaignId;
            if (callbackHandler) {
                callbackHandler.closeCallback = (isCreditUnlocked) => {
                    if (!slot.isActive) {
                        return;
                    }
                    if (!isCreditUnlocked) {
                        reporter.xButton(slot);
                    }
                    if (!slot.credit) {
                        reporter.skip(slot);
                    }
                };
                callbackHandler.handleError = (error) => {
                    handleError(slot, onError, error);
                    resolve();
                };
            }
            const options = {
                network_user_id: getState(State.rtid),
                partner_config_hash: campaignKey,
            };
            global.truex.client(options, (client) => {
                if (slot?.formatDefinition?.reportRequest) {
                    reporter.request(slot);
                }
                client.requestActivity((activity) => {
                    try {
                        if (activity) {
                            activity.onFinish(() => {
                                reporter.end(slot);
                                if (onFinish) {
                                    onFinish({
                                        activity: activity,
                                    });
                                }
                            });
                            activity.onCredit((engagement) => {
                                const unlockProviderData = global.btoa(`${engagement.signature_argument_string}&signature=${encodeURIComponent(engagement.signature)}`);
                                reporter.credit(slot);
                                slot.credit = true;
                                if (onCredit) {
                                    onCredit({
                                        campaignId: campaignId,
                                        unlockProviderData: unlockProviderData,
                                        unlockToken: unlockToken,
                                    });
                                }
                            });
                            client.loadActivityIntoContainer(activity, slot.elementId, {
                                width: activity.window_width,
                                height: activity.window_height,
                            });
                            slot.isActive = true;
                            slot.currentDimensions = [
                                activity.window_width,
                                activity.window_height,
                            ];
                            reporter.start(slot);
                            if (onStart) {
                                onStart(activity.window_width, activity.window_height);
                            }
                        }
                        else {
                            handleError(slot, onError, 'no unlock activity');
                        }
                    }
                    catch (error) {
                        handleError(slot, onError, error);
                    }
                });
                resolve();
            });
        });
    },
};
export default truexNetworkController;
